import { useIntl } from 'react-intl';

import NarratorImage from '@/components/app/program/NarratorImage';
import NarratorRow from '@/components/app/ui/NarratorRow';

import messages from './messages';
import { Bio, CopyWrapper, Name, Wrapper } from './styles';
import { NarratorProps } from './types';

const Narrator = ({ program, theme = 'default', imageAlignment = 'center' }: NarratorProps) => {
	const { formatMessage } = useIntl();
	const name = program?.narrator?.name;

	if (!name) return null;

	if (theme === 'masterclass') {
		return (
			<Wrapper theme={theme}>
				<NarratorImage alignment={imageAlignment} program={program} />
				<CopyWrapper>
					<Name>{name}</Name>
					{program?.narrator?.short_bio && <Bio>{program.narrator.short_bio}</Bio>}
				</CopyWrapper>
			</Wrapper>
		);
	}

	return (
		<NarratorRow
			image={program?.narrator?.headshot}
			title={name}
			subtitle={program?.narrator?.short_bio}
			href={program?.narrator?.id ? `/app/narrator-${program.narrator.id}` : undefined}
			ariaLabel={formatMessage(messages.narratorAriaLabel, { name })}
		/>
	);
};

export default Narrator;
